import { IProduct } from '../models/product.model';

export enum AddReferenceEventEnum {
  selected = 'selected',
  focusOut = 'focusOut'
}

export class AddReferenceFromBOMCommand {

  constructor(private item: IProduct|string, public event: AddReferenceEventEnum, private value?: string) {}

  isSelected() {
    return this.event === AddReferenceEventEnum.selected;
  }

  getItemAsProduct(): IProduct {
    return this.item as IProduct;
  }

  getItemAsString(): string {
    return this.item as string;
  }

  getValue() {
    return this.value;
  }

  isFocusOut() {
    return this.event === AddReferenceEventEnum.focusOut;
  }
}
